import React from "react"
import Modal from "~/components/ui/Modal"
import { SiteProps } from "~/interfaces"
import { validDurations, validElectric } from "~/types"
import Button from "~/components/ui/Button"

interface PricingMatrixConfirmationModalProps {
  open: boolean
  priceKey?: string
  conflictingSites?: SiteProps[]
  newPriceData?: {
    amount_in_cents: number
    duration: validDurations
    electric: validElectric
  }
  onCancelUpdate: () => void
  onConfirmUpdate: () => void
}

const PricingMatrixConfirmationModal = ({open, newPriceData, conflictingSites, onCancelUpdate, onConfirmUpdate }: PricingMatrixConfirmationModalProps) => {
  return (
    <Modal open={open} onClose={onCancelUpdate}>
      <div className="p-4">
        <h2 className="text-xl font-semibold mb-4">Confirm Price Update</h2>
        <p>
          A price configuration with duration "{newPriceData?.duration}" and electric "{newPriceData?.electric}" already exists.
        </p>
        <p>
          Updating will move the following sites to the new price:
        </p>
        <ul className="list-disc pl-6">
          {conflictingSites?.map((site) => (
            <li key={site.id}>Site {site.name}</li>
          ))}
        </ul>
        <p className="mt-4">Do you want to proceed?</p>
        <div className="flex justify-end space-x-4 mt-6">
          <Button onClick={onCancelUpdate} variant="gray">
            No
          </Button>
          <Button onClick={onConfirmUpdate} variant="blue">
            Yes
          </Button>
        </div>
      </div>
    </Modal>
  )
}

export default PricingMatrixConfirmationModal
